module.exports = __webpack_public_path__ + "img/instagram.934654d7.png";